import api from "Common/Client/Interceptor";

const newEmployeesService = {
  getUnassignedLearners: async (token, { pageNumber = 1, pageSize = 10, orderByLatest = false } = {}) => {
    try {
      const response = await api.get(
        `/Learners/GetList?managerAssigned=false&pageNumber=${pageNumber}&pageSize=${pageSize}&orderByLatest=${orderByLatest}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "*/*",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error in getUnassignedLearners:", error);
      throw error; // Optional: propagate to be handled in hook or component
    }
  },

  pickLearnerByManager: async (learnerId, token) => {
    try {
      const response = await api.post(
        `/ManagerLearners/Pick-Learner-ByManager?learnerId=${learnerId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "*/*",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(`Error in pickLearnerByManager for learnerId ${learnerId}:`, error);
      throw error; // Optional: propagate to be handled in hook or component
    }
  },
};

export default newEmployeesService;
